module.exports = __webpack_public_path__ + "static/media/bee.1bf8f501.svg";